import { render, staticRenderFns } from "./PaycheckPrepayments.vue?vue&type=template&id=60b3b332&scoped=true&"
import script from "./PaycheckPrepayments.vue?vue&type=script&lang=ts&"
export * from "./PaycheckPrepayments.vue?vue&type=script&lang=ts&"
import style0 from "./PaycheckPrepayments.vue?vue&type=style&index=0&id=60b3b332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b3b332",
  null
  
)

export default component.exports